import * as React from 'react';
import { useCallback } from 'react';
import Project from 'benchmarking-domain/project';
import { ProjectForm } from 'components/client/projects/project-form';
import useApi from 'hooks/use-api';
import { enqueueSnackbar } from 'notistack';
import { paths } from 'paths';
import { useNavigate } from 'react-router-dom';

import { useOrganisation } from '../../../hooks/use-organisation';

export default function AddProject(): React.JSX.Element {
  const navigate = useNavigate();
  const { organisationId } = useOrganisation();
  const { saveProject } = useApi();

  const submitChanges = useCallback(
    async (data: Project) => {
      if (!organisationId) {
        enqueueSnackbar('Organisation not set!', { variant: 'error' });
        return;
      }

      const newProjectId = await saveProject(organisationId, { ...data, id: '' });

      try {
        enqueueSnackbar('Project added!', { variant: 'success' });
        navigate(paths.app.client.projects.getDetailsUrl(newProjectId));
      } catch (error) {
        enqueueSnackbar('Project save failed! ' + error, { variant: 'error' });
      }
    },
    [navigate, saveProject, organisationId]
  );

  return <ProjectForm onSubmit={submitChanges} />;
}
